import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";

import { WInputText } from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import IconVectorRightBlue from "../../images/icon_button_users_blue.svg";
import { DivOverMaxHeigthIntra } from "./UsersManagementStyles";

const UsersManagementStepOneForm = (props) => {
  const { dataInitialCompany, onSuccess } = props;
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        ruc: new FormControl(null, [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
        ]),
        name: new FormControl(null, []),
        address: new FormControl(null, [Validators.maxLength(75)]),
        phone_number: new FormControl(null, []),
        sunarp_number: new FormControl(null, []),
        contact_name: new FormControl(null, []),
        email: new FormControl(null, [Validators.required, Validators.email]),
        contact_phone_number: new FormControl(null, [Validators.required]),
      });
      if (data) {
        form.disable();
      }
      return form;
    },
    onFormLoaded: (form, data) => {
      form.patchValue(data);
    },
    onSubmit: (form, { succeed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      onSuccess(form.value);
      succeed(dataInitialCompany);
    },
  });

  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed(dataInitialCompany);
  }, [loadSucceed, dataInitialCompany]);

  return (
    <DivOverMaxHeigthIntra>
      <WForm
        formConfig={formConfig}
        globalErrorMessages={{
          minlength: (val) => {
            return `El valor tiene ${val.actualLength}  ha superado el maximo. Pero debe tener minmo ${val.requiredLength}`;
          },
          maxlength: `Max value`,
        }}
      >
        <Toast ref={toast}></Toast>
        <div className="p-grid" style={{ display: "flex" }}>
          <div className="p-md-2" style={{ width: "16.4rem" }}>
            <WFormControl name="ruc">
              <TemplateInputContainer label="RUC:">
                <WInputText width={"16.4rem"} placeholder="RUC" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "34.8rem", marginLeft: "2rem" }}
          >
            <WFormControl name="name">
              <TemplateInputContainer label="Razón Social:">
                <WInputText width={"34.8rem"} placeholder="Razón Social" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="address">
              <TemplateInputContainer label="Dirección Fiscal:">
                <WInputText width={"25.6rem"} placeholder="Dirección fiscal" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="phone_number">
              <TemplateInputContainer label="Teléfono:">
                <WInputText width={"25.6rem"} placeholder="Teléfono" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div
          className="p-grid"
          style={{ display: "flex", marginTop: "3.2rem" }}
        >
          <div className="p-md-2" style={{ width: "25.6rem" }}>
            <WFormControl name="sunarp_number">
              <TemplateInputContainer label="Nro de partida SUNARP:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Nro de partida SUNARP"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="contact_name">
              <TemplateInputContainer label="Personal de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Personal de contacto"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="email">
              <TemplateInputContainer label="Correo electrónico de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Correo electrónico de contacto"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="contact_phone_number">
              <TemplateInputContainer label="Celular de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Celular de contacto"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <SaveButton
            label="Siguiente"
            iconRight={IconVectorRightBlue}
            width="25.6rem"
            height="6rem"
            fontSize="1.6rem"
            backgroundColor="#88B13B"
          />
        </div>
      </WForm>
    </DivOverMaxHeigthIntra>
  );
};

export default UsersManagementStepOneForm;
